import strapiApi from "./strapiApi"

export const blogsAPI = {
  // Fetch all blogs
  getAllBlogs: async () => {
    try {
      const response = await strapiApi.get('/blog-posts?populate=*'); // Strapi endpoint
      // Strapi v4 returns { data: [...] }
      return response.data.data.map((item) => ({
        id: item.id,
        title: item.Title,
        summary: item.summary,
        conent: item.content,
        slug: item.slug,
        date: item.publishedAt,
        isPublished: item.published,
        image: item.Media,
      }));
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Fetch a single blog by slug
  getBlogBySlug: async (slug) => {
    try {
      const response = await strapiApi.get(
        `/blog-posts?filters[slug][$eq]=${slug}&populate=*`
      );
      const item = response.data.data[0];
      if (!item) return null;
      return {
        id: item.id,
        title: item.Title,
        summary: item.summary,
        slug: item.slug,
        date: item.publishedAt,
        content: item.content,
        image: item.Media,
      };
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};
